import { useEffect, useState } from 'react'

export const useEffectOnceWhenReady = (
  callback: () => void,
  dependencies: boolean[],
  tryCatchFinally?: {
    catch?: (error: unknown) => void
    finally?: () => void
  },
) => {
  // State to track initialization status
  const [alreadyRan, setAlreadyRan] = useState(false)

  useEffect(() => {
    if (!alreadyRan && dependencies.every((dep) => dep)) {
      if (!tryCatchFinally) {
        callback()
        setAlreadyRan(true)
        return
      }

      try {
        callback()
        setAlreadyRan(true)
      } catch (error) {
        tryCatchFinally.catch?.(error)
      } finally {
        tryCatchFinally.finally?.()
      }
    }
  }, [alreadyRan, ...dependencies])
}
